import 'styles/antd.less';
import 'styles/bootstrap/bootstrap.scss'
import "styles/layout.scss"
import "styles/theme.scss"
import "styles/ui.scss"
import "styles/vendors.scss"

import { Redirect, Route } from 'react-router-dom';

import LoadingComponent from 'components/Loading';
import React from 'react';
import loadable from 'react-loadable';
import Axios from 'axios';
import { connect } from 'react-redux';

let AsyncAppLayout = loadable({
  loader: () => import('components/Layout/AppLayout/'),
  loading: LoadingComponent
})
let AsyncException = loadable({
  loader: () => import('routes/exception/'),
  loading: LoadingComponent
})
let AsyncAccount = loadable({
  loader: () => import('routes/user/'),
  loading: LoadingComponent
})
let OAuth2Get = loadable({
  loader: () => import('routes/oauth2/'),
  loading: LoadingComponent
})
let AsyncCourseWizard = loadable({
  loader: () => import('components/Layout/AppLayout/CourseWizard'),
  loading: LoadingComponent
})
let ZoomGet = loadable({
  loader: () => import('routes/zoomget/'),
  loading: LoadingComponent
})
let AsyncSemantik = loadable({
  loader: () => import('components/Layout/AppLayout/KlcSemantik'),
  loading: LoadingComponent
})


class App extends React.Component {
  componentDidMount(){
    if(this.props.DataToken!==null){
      Axios.interceptors.request.use(config => {
        config.headers = { Authorization: `Bearer ${this.props.DataToken}`};
        return config;
      }, error => {
        return Promise.reject(error);
      });
    }
  }
  render() {
    const { match, location } = this.props;
    const isRoot = location.pathname === '/' ? true : false;
    if (isRoot) {
      return ( <Redirect to={'/user/login'}/> );
    }

    return (
      <div id="app">
        <Route path={`${match.url}app`} component={AsyncAppLayout} />
        <Route path={`${match.url}exception`} component={AsyncException} />
        <Route path={`${match.url}user`} component={AsyncAccount} />
        <Route path={`${match.url}course-wizard`} component={AsyncCourseWizard} />
        <Route path={`${match.url}oauth2-get`} component={OAuth2Get} />
        <Route path={`${match.url}zoom-get`} component={ZoomGet} />
        <Route path={`${match.url}sem`} component={AsyncSemantik} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  DataToken: state.settings.token
});

export default connect(
  mapStateToProps,
  null
)(App);
